import { thunkProgress } from 'redux-progress';

import type { Dispatch, GetState } from 'model/State';
import {
  archiveUnarchiveLicense,
  developerLicense,
  getLicenseById,
} from 'modules/mac/duck/api/license';
import { ARCHIVE_UNARCHIVE_LICENSE, DEVELOPER_LICENSE, LICENSE_DETAILS } from './types';

export const postArchiveUnarchiveLicense =
  (licenseId: number, isArchived: boolean) => (dispatch: Dispatch, getState: GetState) => {
    const state = getState();

    if (!licenseId) return;

    const archiveUnarchiveLicenseData = archiveUnarchiveLicense(
      licenseId,
      isArchived || false,
      state,
    );
    dispatch(thunkProgress(ARCHIVE_UNARCHIVE_LICENSE, archiveUnarchiveLicenseData));
  };

export const fetchDeveloperLicense = (id: number) => (dispatch: Dispatch, getState: GetState) => {
  const state = getState();

  const developerLicenseData = developerLicense(id, state);
  dispatch(thunkProgress(DEVELOPER_LICENSE, developerLicenseData, { id }));
};

export const fetchLicenseById =
  (id: number, ufoName: string = '') =>
  (dispatch: Dispatch, getState: GetState) => {
    const state = getState();

    const license = getLicenseById(id, state, ufoName);
    dispatch(thunkProgress(LICENSE_DETAILS, license, { id }));
  };
